import { AppResourcePage } from './app-resource-base';
import { branchSwitchOnResource } from './helpers/branch-switch';
import { createConcurrencyCheck, ResourceLocker } from '../common/resource-lock';
import {
  createPurchaseOrderView,
  getPurchaseOrderContainer,
  getPurchaseOrderContainerManager,
  PurchaseOrderLock
} from '../purchase-orders/purchase-order-ui-adapter';
import { customElement } from 'lit/decorators.js';
import { goStaticURL } from '../../../webmodule-common/other/ui/resource-resolver';
import { isEmptyOrSpace } from '../../../webmodule-common/other/ui/string-helper-functions';
import { LangAppPurchaseOrderPage } from '../../../localization/scripts/dealer-franchisee/pages/app-purchase-order-lang';
import { ModalViewBase } from '../../../webmodule-common/other/ui/data-entry-screen-base';
import { NullPromise } from '../../../webmodule-common/interop/types/misc';
import { PurchaseOrderContainerManager } from '../../purchase-orders/data/purchase-order-container';

@customElement('app-purchase-order')
export class AppPurchaseOrderPage extends AppResourcePage {
  pom?: PurchaseOrderContainerManager;

  async createModalEditor(orderId: string): NullPromise<ModalViewBase> {
    const container = getPurchaseOrderContainer(orderId);
    if (isEmptyOrSpace(orderId)) orderId = container.purchaseOrderId;

    this.pom = getPurchaseOrderContainerManager(container, () => !this.lock?.isLockOwner);
    await this.pom.needsPurchaseOrder();

    if (!(await branchSwitchOnResource(this.pom.quoteOwnerId, LangAppPurchaseOrderPage.purchaseOrderGlossary())))
      return null;

    return await createPurchaseOrderView(this.pom);
  }

  async redirectPath(): NullPromise<string> {
    return '/purchase-orders';
  }

  meta() {
    return {
      title: () => LangAppPurchaseOrderPage.purchaseOrderEditorTitle(),
      description: 'SoftTech dealer CPQ'
    };
  }

  protected createLock(id: string): ResourceLocker | undefined {
    const lockRevokedEvent = async () => {
      await this.view?.abandonAndClose(true);
      goStaticURL('/purchase-orders');
    };

    // Create concurrency check that ensures local data is loaded and compares recordVersion with server
    const concurrencyCheck = createConcurrencyCheck('FRANCHISEE.PURCHASEORDER', id, async () => {
      await this.pom?.needsPurchaseOrder();
      return this.pom?.purchaseOrder?.recordVersion ?? '';
    });

    return new PurchaseOrderLock(id, lockRevokedEvent, concurrencyCheck);
  }
}
